import { useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";

import bg from "../../../../../Assets/StoryRunner/phone.png";

import connectWithDispatch from "../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../Actions/appActions";

import Screen1 from "./phone/Screen1";
import Screen2 from "./phone/Screen2";
import Screen3 from "./phone/Screen3";
import Screen4 from "./phone/Screen4";
import Screen5 from "./phone/Screen5";
import Screen6 from "./phone/Screen6";
import Screen7 from "./phone/Screen7";
import Screen8 from "./phone/Screen8";
import Screen9 from "./phone/Screen9";
import Screen10 from "./phone/Screen10";
import Screen11 from "./phone/Screen11";
import Screen12 from "./phone/Screen12";
import Screen13 from "./phone/Screen13";

import ScreenAnimator from "../../../../Commons/ScreenAnimator";

interface StageProps {
  stage: number;
  transition: number;
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
  t: (key: string) => ReactNode;
}

const StageThree = (props: StageProps) => {
  const { stage, transition, setStory, screen } = props;

  const animacion = useSpring(
    transition >= 2
      ? {
          from: {
            transform: "translateY(120%) rotate(-30deg)",
          },
          to: {
            transform: "translateY(0%) rotate(0deg)",
          },
          config: {
            duration: 500,
            tension: 300,
            friction: 20,
          },
        }
      : {
          transform: "translateY(120%) rotate(-30deg)",
        }
  );

  useEffect(() => {
    if (transition === 1 && screen === 0) setTimeout(() => setStory({ transition: transition + 1, screen: 1 }), 100);
    if (transition === 2) setTimeout(() => setStory({ transition: transition + 1 }), 1000);
    if (transition === 3) setTimeout(() => setStory({ transition: transition + 1 }), 1000);

    return () => {};
  }, [transition, screen, setStory]);

  useEffect(() => {
    if (screen === 1) setTimeout(() => setStory({ screen: screen + 1 }), 4500);
    if (screen === 14) setTimeout(() => setStory({ stage: stage + 1, transition: 1, screen: 0 }), 1500);
    return () => {};
  }, [screen, stage, setStory]);

  const propsOpacity = useSpring({
    zIndex: screen === 14 ? 100 : -1,
    background: "#000",
    position: "absolute" as "absolute",
    width: "100vw",
    height: "100vh",
    opacity: screen === 14 ? 1 : 0,
    config: { duration: 500 },
  });

  return (
    <>
      <animated.div style={{ background: screen <= 14 ? `url(${bg})` : "none", ...styles.bgTablet, ...animacion }}>
        <ScreenAnimator
          width={"124.07vh"}
          currentScreen={screen - 1}
          screens={[
            <Screen1 />,
            <Screen2 />,
            <Screen3 />,
            <Screen4 />,
            <Screen5 />,
            <Screen6 />,
            <Screen7 />,
            <Screen8 />,
            <Screen9 />,
            <Screen10 />,
            <Screen11 />,
            <Screen12 />,
            <Screen13 />,
          ]}
        />
        <animated.div style={propsOpacity}></animated.div>
      </animated.div>
    </>
  );
};

const styles = {
  bgTablet: {
    backgroundSize: "contain",
    backgroundPosition: "center center",
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundRepeat: "no-repeat",
  },

  imgScreen: {
    objectFit: "contain" as "contain",
    width: "100%",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    stage: state.appReducer.story.stage,
    transition: state.appReducer.story.transition,
    screen: state.appReducer.story.screen,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(StageThree, mapStateToProps, mapDispatchToProps);
